import { render, staticRenderFns } from "./PageDayCare.vue?vue&type=template&id=4b4808ac&scoped=true&"
import script from "./PageDayCare.vue?vue&type=script&lang=js&"
export * from "./PageDayCare.vue?vue&type=script&lang=js&"
import style0 from "./PageDayCare.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PageDayCare.vue?vue&type=style&index=1&id=4b4808ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4808ac",
  null
  
)

export default component.exports